<div class="h-full w-full rounded-lg">
    <app-lazy-picture
        [additionalClasses]="['rounded-lg h-full']"
        [configurations]="featuredImageConfiguration"></app-lazy-picture>
</div>
